export class ChatInfiniteScroll {
  constructor() {
    return {
      restrict: 'E',
      scope: {
        offset: '=chatInfiniteScrollOffset',
        element: '=chatInfiniteScrollElement',
        callback: '=chatInfiniteScrollCallback',
        active: '=?chatInfiniteScrollActive',
        direction: '=chatInfiniteScrollDirection',
        options: '=chatInfiniteScrollOptions'
      },
      link: function link(scope, elm, attrs) {
        if(scope.active === undefined) {
          scope.active = true;
        }

        if(scope.element) {
          elm = $(scope.element);
        }

        let raw = elm[0];

        if(scope.options && scope.options.chat_room && $._data($(scope.element)[0], 'events')) elm.unbind('scroll');
        elm.bind('scroll', () => {
          switch(scope.direction) {
            case 'top':
            function checkParent(obj, key) {
              if(obj) {
                if(obj.hasOwnProperty(key)) {
                  return obj;
                } else if(obj.hasOwnProperty('$parent')) {
                  return checkParent(obj.$parent, key);
                }
              }

              return {
                activeChatOptions: null
              }
            }

              let parentScope = checkParent(scope, 'activeChatOptions');

              if(raw.scrollTop - scope.offset < 0 && parentScope.activeChatOptions) {
                scope.callback(scope.options.chat_room, scope.options.page + 1, scope.options.limit)
              }
              break;
            case 'bottom':
              if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight * ((100 - (scope.offset || 0)) / 100)) {
                scope.$apply(() => {
                  scope.callback();
                })
              }
          }
        })
      }
    }
  }
}
